// removed by extract-text-webpack-plugin
module.exports = {"page-cover":"style__page-cover___3OfIP","uil-spin-css":"style__uil-spin-css___BXhEr"};


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Loading/style.scss
// module id = 1300
// module chunks = 0